export default __webpack_public_path__ + "not-found-404.d3d56afbd43bdcfece0efbbb5a25323c.svg";